<template>
   <svg name="arrow-short-line" viewBox="0 0 27 19" aria-hidden="true" focusable="false">
      <path
         d="M25.8839 10.38C26.372 9.89182 26.372 9.10037 25.8839 8.61221L17.9289 0.657261C17.4408 0.169105 16.6493 0.169105 16.1612 0.65726C15.673 1.14542 15.673 1.93687 16.1612 2.42503L23.2322 9.4961L16.1612 16.5672C15.673 17.0553 15.673 17.8468 16.1612 18.3349C16.6493 18.8231 17.4408 18.8231 17.9289 18.3349L25.8839 10.38ZM-1.09278e-07 10.7461L25 10.7461L25 8.2461L1.09278e-07 8.24609L-1.09278e-07 10.7461Z"
         fill="#FFF5F3"
      />
   </svg>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped></style>
